const actions = {
	GET_DESCRIBE_IMAGE: 'GET_DESCRIBE_IMAGE',
	GET_DESCRIBE_IMAGE_SUCCESS: 'GET_DESCRIBE_IMAGE_SUCCESS',

	CREATE_NEW_QUESTION_DESCRIBE_IMAGE: 'CREATE_NEW_QUESTION_DESCRIBE_IMAGE',
	CREATE_NEW_QUESTION_DESCRIBE_IMAGE_SUCCESS: 'CREATE_NEW_QUESTION_DESCRIBE_IMAGE_SUCCESS',

	DELETE_DESCRIBE_IMAGE: 'DELETE_DESCRIBE_IMAGE',
	DELETE_DESCRIBE_IMAGE_SUCCESS: 'DELETE_DESCRIBE_IMAGE_SUCCESS',

	GET_DESCRIBE_IMAGE_DETAIL: 'GET_DESCRIBE_IMAGE_DETAIL',
	GET_DESCRIBE_IMAGE_DETAIL_SUCCESS: 'GET_DESCRIBE_IMAGE_DETAIL_SUCCESS',

	UPDATE_DESCRIBE_IMAGE_DETAIL: 'UPDATE_DESCRIBE_IMAGE_DETAIL',
	UPDATE_DESCRIBE_IMAGE_DETAIL_SUCCESS: 'UPDATE_DESCRIBE_IMAGE_DETAIL_SUCCESS',

	SPEAKING_LOADING_FALSE: 'SPEAKING_LOADING_FALSE',
	//#region CRUD

	getDescribeImage: (model) => ({
		type: actions.GET_DESCRIBE_IMAGE,
		payload: { model },
	}),

	createQuesDescribeImage: (body, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_QUESTION_DESCRIBE_IMAGE,
		payload: { body },
		cbSuccess,
		cbError,
	}),

	getDescribeImageDetail: (id) => ({
		type: actions.GET_DESCRIBE_IMAGE_DETAIL,
		payload: { id },
	}),

	updateDescribeImageDetail: (model, cbSuccess, cbError) => ({
		type: actions.UPDATE_DESCRIBE_IMAGE_DETAIL,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	deleteDescribeImage: (id, cbSuccess, cbError) => ({
		type: actions.DELETE_DESCRIBE_IMAGE,
		payload: { id },
		cbSuccess,
		cbError,
	}),
};

export default actions;
